module.exports = __webpack_public_path__ + "img/trashIcon_gray2.2bd0dd63.svg";